import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import React, {useState} from "react";
import {OrderStatusEnum} from "../../../config/orderStatusEnum"

export const styles = {
  dropdownGeneral: {
    backgroundColor: "#4fb4d7",
    width: "100%"
  }
};

type OrderStatusDropdownProps = {
  orderStatus: OrderStatusEnum,
  changeOrderStatus: (orderStatus: OrderStatusEnum) => void
}

const OrderStatusDropdown = ({orderStatus, changeOrderStatus}: OrderStatusDropdownProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret style={styles.dropdownGeneral}>{OrderStatusEnum[orderStatus]}</DropdownToggle>
      <DropdownMenu flip={false}>
        {Object.keys(OrderStatusEnum).map(item => (
          <DropdownItem key={item}>
            <div onClick={() => changeOrderStatus(item)}>{OrderStatusEnum[item]}</div>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}


export default OrderStatusDropdown;
